import { prop } from '@ipfabric/utils/fp/prop';
import { useGlobalStateContextSelectors } from 'components/GlobalState/GlobalStateModel';

export type PermissionScope = 'read' | 'settings' | 'team' | 'write';
type UsePermissionScopeHook = PermissionScope[];

export const usePermissionScope = (): UsePermissionScopeHook => {
  const ctxProps = useGlobalStateContextSelectors({
    scope: prop('auth', 'scope'),
  });

  return ctxProps.scope;
};
